import { proxy } from "valtio";
import { PopulationSegment } from "@models/populationSegment.model";

interface OrganizationSegmentsState {
  organizationId: number | null;
  segments: PopulationSegment[];
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const organizationSegmentsStore = proxy<OrganizationSegmentsState>({
  organizationId: null,
  segments: [],
  isLoading: false,
  isSaving: false,
  error: null,
});

export function resetOrganizationSegmentsStore() {
  organizationSegmentsStore.organizationId = null;
  organizationSegmentsStore.segments = [];
  organizationSegmentsStore.isLoading = false;
  organizationSegmentsStore.isSaving = false;
  organizationSegmentsStore.error = null;
}
